<!-- src/tilelist/components/benefit-cinema/BenefitCinemaProvider.svelte -->
<script lang="ts">
    import type { Snippet } from 'svelte';
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
    import { setContext } from 'svelte';
    import { defaultFetchClient } from '@shared/clients/BrowserFetchClient.browser.ts';
    import { DynamicEsiClient } from '@shared/components/dynamic-esi/DynamicEsiClient.ts';
    import { log } from '@shared/log.browser.ts';
    import { BENEFIT_CINEMA_CONTEXT, BenefitCinemaStore, type CinemaClient } from './BenefitCinemaStore.svelte.ts';

    interface Props {
        rule: string;
        children?: Snippet;
    }

    let { rule, children }: Props = $props();

    const client: CinemaClient = new DynamicEsiClient({
        name: 'BenefitCinema',
        fetchClient: defaultFetchClient,
        logger: log,
    });
    const store = new BenefitCinemaStore(client);
    setContext(BENEFIT_CINEMA_CONTEXT, store);

    /*                                                                            */
    /*                                                                */
    /*                                     */
    let previousRule = rule;

    $effect(() => {
        if (rule === previousRule) return;
        previousRule = rule;
        store.fetch(rule);
    });
</script>

{#if children}{@render children()}{/if}
